import { render } from "./halfSizeTeaser.vue?vue&type=template&id=7d93d76c"
import script from "./halfSizeTeaser.vue?vue&type=script&lang=js"
export * from "./halfSizeTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__